import { Link } from "react-router-dom";

const CreativeAgencyTwoPortfolioPost = () => {
  return (
    <>
      <div className="ca-two-portfolio-post-area pb-250 position-relative">
        <div className="container-fluid">
          <div className="position-relative z-1">
            <img
              src="assets/img/creative-agency-2/shape/pfp.png"
              alt=""
              className="pfp-shape position-absolute z--1"
            />
            <div className="container">
              <div className="position-relative">
                <img
                  src="assets/img/creative-agency-2/shape/2.png"
                  alt=""
                  className="shape-two position-absolute"
                />
                <h6 className="ca-two-subtitle ca-two-body-clr-two d-flex align-items-center mb-85 ca-two-pt-10">
                  <span className="ca-two-bg-two"></span>Portfolio Works
                </h6>
                <div className="row align-items-center">
                  <div className="col-xl-6">
                    <h2 className="ca-two-title ca-two-body-clr-two fs-36 fw-500 flh-48 pr-20">
                      A design-focused approach for planning, reviewing, &
                      creative predesigning
                    </h2>
                  </div>
                  <div className="col-xl-6">
                    <div className="text-end opacity-15">
                      <h1 className="ca-two-body-clr fw-500 fs-72 mb-0">
                        Quiety Portfolio
                      </h1>
                    </div>
                  </div>
                </div>
                <div className="ca-two-pf-posts">
                  <div className="row">
                    <div className="col-md-5">
                      <div className="ca-two-pf-post position-relative mt-30">
                        <img
                          src="assets/img/creative-agency-2/portfolio_post.png"
                          alt=""
                          className="ca-two-pf-img img-fluid rounded-16 img-fluid"
                        />
                        <Link href="assets/img/creative-agency-two">
                          <h6 className="ca-two-pf-cet ca-two-subtitle two ca-two-body-clr ff-dmsans d-flex ca-two-bg-five align-items-center mb-0 position-absolute z-2">
                            <span className="ca-two-bg-four"></span>3D
                            Illustration
                          </h6>
                        </Link>
                      </div>
                      <div className="ca-two-pf-post position-relative mt-30">
                        <img
                          src="assets/img/creative-agency-2/portfolio_post_2.png"
                          alt=""
                          className="ca-two-pf-img img-fluid rounded-16 img-fluid"
                        />
                        <Link href="assets/img/creative-agency-two">
                          <h6 className="ca-two-pf-cet ca-two-subtitle two ca-two-body-clr ff-dmsans d-flex ca-two-bg-five align-items-center mb-0 position-absolute z-2">
                            <span className="ca-two-bg-four"></span>Web Design
                          </h6>
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="ca-two-pf-post position-relative mt-30">
                        <img
                          src="assets/img/creative-agency-2/portfolio_post_3.png"
                          alt=""
                          className="ca-two-pf-img img-fluid rounded-16 img-fluid w-100"
                        />
                        <Link href="assets/img/creative-agency-two">
                          <h6 className="ca-two-pf-cet ca-two-subtitle two ca-two-body-clr ff-dmsans d-flex ca-two-bg-five align-items-center mb-0 position-absolute z-2">
                            <span className="ca-two-bg-four"></span>Mobile App
                          </h6>
                        </Link>
                      </div>
                      <div className="ca-two-pf-post position-relative mt-30">
                        <img
                          src="assets/img/creative-agency-2/portfolio_post_4.png"
                          alt=""
                          className="ca-two-pf-img img-fluid rounded-16 img-fluid w-100"
                        />
                        <Link href="assets/img/creative-agency-two">
                          <h6 className="ca-two-pf-cet ca-two-subtitle two ca-two-body-clr ff-dmsans d-flex ca-two-bg-five align-items-center mb-0 position-absolute z-2">
                            <span className="ca-two-bg-four"></span>Digital
                            Marketing
                          </h6>
                        </Link>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="ca-two-pf-post position-relative mt-30">
                        <img
                          src="assets/img/creative-agency-2/portfolio_post_5.png"
                          alt=""
                          className="ca-two-pf-img img-fluid rounded-16 img-fluid w-100"
                        />
                        <Link href="assets/img/creative-agency-two">
                          <h6 className="ca-two-pf-cet ca-two-subtitle two ca-two-body-clr ff-dmsans d-flex ca-two-bg-five align-items-center mb-0 position-absolute z-2">
                            <span className="ca-two-bg-four"></span>3D Render
                          </h6>
                        </Link>
                      </div>
                      <div className="ca-two-pf-post position-relative mt-30">
                        <img
                          src="assets/img/creative-agency-2/portfolio_post_6.png"
                          alt=""
                          className="ca-two-pf-img img-fluid rounded-16 img-fluid w-100"
                        />
                        <Link href="assets/img/creative-agency-two">
                          <h6 className="ca-two-pf-cet ca-two-subtitle two ca-two-body-clr ff-dmsans d-flex ca-two-bg-five align-items-center mb-0 position-absolute z-2">
                            <span className="ca-two-bg-four"></span>UI UX Design
                          </h6>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <svg
            width="1840"
            height="1122"
            viewBox="0 0 1840 1122"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M236 0C249.255 0 260 10.7452 260 24C260 37.2548 270.745 48 284 48H436C449.255 48 460 37.2548 460 24C460 10.7452 470.745 0 484 0H1816C1829.25 0 1840 10.7452 1840 24V990V997V1098C1840 1111.25 1829.25 1122 1816 1122H1404C1390.75 1122 1380 1111.25 1380 1098V1045C1380 1031.75 1369.25 1021 1356 1021H24C10.7451 1021 0 1010.25 0 997V24C0 10.7451 10.7452 0 24 0H236Z"
              fill="#F6F6F6"
            />
          </svg>
        </div>
      </div>
    </>
  );
};

export default CreativeAgencyTwoPortfolioPost;
